import React, { useEffect } from 'react'
import { Typography, Button } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';

function Manuales() {

    useEffect(() => {
    }, [])

    return (
        <div className='container'>
            <div>
                <div className='header'>
                    <h1 className='centrar'>Manuales</h1>
                </div>
                <div className='homeContainer'>
                    <div className='homeContainerHeader'>
                        <Typography variant="h5" component="div" className='centrar'>
                            Manuales Workers
                        </Typography>
                    </div>
                    <div className='containerButtonContainer'>
                        <div className='enlaces-button'>
                            <Button className="nuevo-button custom-button" onClick={() => { window.open('https://api.workers.grupotel.com/documentos/manuales/QRWorkersIphone.webp'); }}>
                                <span
                                    className="centrarTodo"
                                ><QrCodeScannerIcon className='icon-button-Grande' /></span>
                                <span className="custom-button-label">Instalar Iphone</span>
                            </Button>
                        </div>
                        <div className='enlaces-button'>
                            <Button className="en-ejecucion-button custom-button" onClick={() => { window.open('https://api.workers.grupotel.com/documentos/manuales/workersAndroid.pdf'); }}>
                                <span
                                    className="centrarTodo"
                                ><PictureAsPdfOutlinedIcon className='icon-button-Grande' /></span>
                                <span className="custom-button-label">Instalar Android</span>
                            </Button>
                        </div>
                        <div className='enlaces-button'>
                            <Button className="terceros-button custom-button" onClick={() => { window.open('https://api.workers.grupotel.com/documentos/manuales/Manual%20Workers%202.0.pdf'); }}>
                                <span
                                    className="centrarTodo"
                                ><PictureAsPdfOutlinedIcon className='icon-button-Grande' /></span>
                                <span className="custom-button-label">Workers PC</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Manuales;

